/**
 * Card Reducer
 */

import { Actions } from "containers/Transfer/store/Actions";
import { Reducer } from "redux";
import { getTransferFormTranslations } from "root/shared/MultiLanguage";
import {
  IInputProps,
  IRadioGroupProps,
  ISelectItem,
  ISelectProps,
} from "root/store/CajitaStore";
import { ITransferActionCreator } from "types/transfer_action_creator";
import { ITransferFormProps } from "types/transfer_form_props";

const documentTypeClass: string[] = ["left", "select-pse"];

const initialState: ITransferFormProps = {
  is_subscription: false,
  isTransferAvailable: true,
  transferType: "",
  isValid: false,
  bankListSelect: {
    id: "bankListSelect",
    value: "0",
    classes: ["section", "select-pse"],
    inputItems: [],
  },
  userTypeRadioGroup: {
    id: "userTypeRadioGroup",
    selected: "0",
    items: [
      {
        value: "0",
      },
      {
        value: "1",
      },
    ],
  },
  documentTypeSelect: {
    id: "documentTypeSelect",
    value: "CC",
    classes: documentTypeClass,
    inputItems: [
      { value: "CC", text: "CC" },
      { value: "NIT", text: "NIT" },
      { value: "CE", text: "CE" },
      { value: "TI", text: "TI" },
      { value: "PP", text: "PP" },
      { value: "RUT", text: "RUT" },
      { value: "CURP", text: "CURP" },
      { value: "RFC", text: "RFC" },
    ],
  },
  documentNumberInput: {
    container: "transfer",
    value: "",
    classContainer: "inputContainer",
    valid: false,
    dirty: false,
    classes: ["input", "reference-input", "input-without-icon"],
    inputPattern: /^[a-zA-Z0-9]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 20,
      minLength: 6,
    },
    attributes: {
      id: "documentNumberInput",
      type: "text",
    },
  },
  documentEmailInput: {
    container: "transfer",
    value: "",
    classContainer: "inputContainer email-transfer-input",
    valid: true,
    dirty: false,
    classes: ["input"],
    inputPattern: /^[a-zA-Z0-9._+-@]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: false,
      maxLength: 100,
    },
    attributes: {
      id: "documentEmailInput",
      type: "text",
    },
  },
  paymentDescriptionInput: {
    container: "transfer",
    value: "",
    classContainer: "inputContainer description-transfer-input",
    valid: false,
    dirty: false,
    classes: ["input"],
    inputPattern: /^[ A-Za-z0-9àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "paymentDescriptionInput",
      type: "text",
    },
  },
  translation: getTransferFormTranslations(),
};

// tslint:disable-next-line:max-func-body-length
const TransferReducer: Reducer<ITransferFormProps> = (
  state: ITransferFormProps = initialState,
  action: ITransferActionCreator
): ITransferFormProps => {
  let input: IInputProps;
  let select: ISelectProps;
  let radio_group: IRadioGroupProps;
  let selectItems: { id: string; items: ISelectItem[] };

  switch (action.type) {
    case Actions.UPDATE_TRANSFER_INPUT:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: input,
      };
    case Actions.SET_TRANSFER_INPUT_DIRTY:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: {
          ...state[input.attributes.id],
          dirty: true,
        },
      };
    case Actions.UPDATE_SELECT_VALUE:
      select = action.select as ISelectProps;

      return {
        ...state,
        [select.id]: select,
      };
    case Actions.UPDATE_RADIO_GROUP:
      radio_group = action.radioGroup as IRadioGroupProps;

      return {
        ...state,
        [radio_group.id]: radio_group,
      };
    case Actions.SWITCH_TRANSFER_VALIDITY:
      return {
        ...state,
        isValid: !state.isValid,
      };
    case Actions.SET_TRANSFER_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    case Actions.SET_BANK_LIST_ITEMS:
      selectItems = action.selectItems as { id: string; items: ISelectItem[] };

      return {
        ...state,
        isTransferAvailable: true,
        [selectItems.id]: {
          ...state[selectItems.id],
          inputItems: selectItems.items,
        },
      };
    case Actions.DISABLE_TRANSFER_FORM:
      return {
        ...state,
        isTransferAvailable: false,
      };
    case Actions.SET_TRANSFER_CHILE:
      return {
        ...state,
        transferType: "Chile",
        documentTypeSelect: {
          id: "documentTypeSelect",
          value: "RUT",
          classes: documentTypeClass,
          inputItems: [
            { value: "RUT", text: "RUT" },
            { value: "CC", text: "CC" },
            { value: "NIT", text: "NIT" },
            { value: "TI", text: "TI" },
            { value: "PP", text: "PP" },
            { value: "CE", text: "CE" },
          ],
        },
        processorName: action.processorName,
      };
    case Actions.SET_TRANSFER_COLOMBIA:
      return {
        ...state,
        transferType: "Colombia",
        documentTypeSelect: {
          id: "documentTypeSelect",
          value: "CC",
          classes: documentTypeClass,
          inputItems: [
            { value: "CC", text: "CC" },
            { value: "NIT", text: "NIT" },
            { value: "CE", text: "CE" },
            { value: "TI", text: "TI" },
            { value: "PP", text: "PP" },
          ],
        },
      };
    case Actions.SET_TRANSFER_MEXICO:
      return {
        ...state,
        transferType: "Mexico",
        documentTypeSelect: {
          id: "documentTypeSelect",
          value: "PP",
          classes: documentTypeClass,
          inputItems: [
            { value: "PP", text: "PP" },
            { value: "CURP", text: "CURP" },
            { value: "RFC", text: "RFC" },
          ],
        },
      };
    case Actions.SET_TRANSFER_PERU:
      return {
        ...state,
        transferType: "Peru",
        documentTypeSelect: {
          id: "documentTypeSelect",
          value: "DNI",
          classes: documentTypeClass,
          inputItems: [
            { value: "DNI", text: "DNI" },
            { value: "CE", text: "CE" },
            { value: "PAS", text: "PAS" },
          ],
        },
      };
    case Actions.SET_TRANSFER_ECUADOR:
      return {
        ...state,
        transferType: "Ecuador",
        documentTypeSelect: {
          id: "documentTypeSelect",
          value: "CI",
          classes: documentTypeClass,
          inputItems: [
            { value: "CI", text: "CI" },
            { value: "RUC", text: "RUC" },
            { value: "PAS", text: "PAS" },
          ],
        },
      };
    default:
      return state;
  }
};

export { TransferReducer };



// WEBPACK FOOTER //
// ./src/containers/Transfer/store/Reducer.tsx